import { getLabel } from "../../../../hooks/use-labels";

export function formDataFields() {
  return {
    "delete-account": {
      title: getLabel("deleteAccount"),
      subTitle: getLabel("deleteAccountContent"),
      alert: getLabel("deleteWaringContent"),
      icon: "/assets/icons/delete-consumer.svg",
      fields: {
        otp: {
          elementConfigs: {
            label: "",
            type: "otp",
            name: "otp",
            required: true,
            className: "single-form-item",
          },
          value: "",
        },
      },
      text: getLabel("deleteLabel"),
      footerText: getLabel("poweredBy"),
    },
  };
}
